import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-page',
  templateUrl: './blank-page.component.html',
  styleUrls: ['./blank-page.component.scss']
})
export class BlankPageComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParamMap
      .subscribe((params) => {
          const certificateId = params.get('certificateId');
          const serialNumber = params.get('serialNumber');
          const token = localStorage.getItem('token') || sessionStorage.getItem('token');
          if (token) {
            this.router.navigate(['/home-enterprise'], { state: {key: 'send-confirm', certificateId, serialNumber } });
          } else {
            this.router.navigate(['/enterprise-login'], { state: {key: 'send-confirm', certificateId, serialNumber } });
          }
        }
      );
  }

}
